import React from 'react';
import { IconButton, Menu, MenuItem, Tooltip, Box } from '@mui/material';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import SettingsBrightnessIcon from '@mui/icons-material/SettingsBrightness';
import CheckIcon from '@mui/icons-material/Check';
import { ThemeMode, useThemeContext } from '../context/ThemeContext';

const modeIcons: Record<ThemeMode, React.ReactNode> = {
  light: <LightModeOutlinedIcon fontSize="small" />,
  dark: <DarkModeOutlinedIcon fontSize="small" />,
  system: <SettingsBrightnessIcon fontSize="small" />,
};

const ThemeSelector: React.FC = () => {
  const { mode, setMode, isDark } = useThemeContext();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const activeThemeIconMode: ThemeMode = mode === 'system' ? (isDark ? 'dark' : 'light') : mode;

  return (
    <>
      <Tooltip title="Theme">
        <IconButton
          onClick={(e) => setAnchorEl(e.currentTarget)}
          size="small"
          sx={{ p: 0.5, color: 'text.secondary', '&:hover': { bgcolor: 'action.hover' } }}
        >
          {modeIcons[activeThemeIconMode]}
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ sx: { minWidth: 150, mt: 0.5 } }}
        MenuListProps={{ sx: { py: 0 } }}
      >
        {(['light', 'dark', 'system'] as ThemeMode[]).map((m) => (
          <MenuItem
            key={m}
            onClick={() => {
              setMode(m);
              setAnchorEl(null);
            }}
            sx={{ gap: 1.5, fontSize: 12, py: 1 }}
          >
            <Box sx={{ color: 'text.secondary', display: 'flex', alignItems: 'center' }}>
              {modeIcons[m]}
            </Box>
            {m === 'light' ? 'Light' : m === 'dark' ? 'Dark' : 'System'}
            {mode === m && (
              <CheckIcon fontSize="small" sx={{ ml: 'auto', color: 'primary.main' }} />
            )}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ThemeSelector;
